import { Component } from "react";
import PropTypes from "prop-types";
import { AppInsights } from "applicationinsights-js";
import away from "away";

 export default class AppInsightsTracker extends Component {
  constructor() {
    super();
    this.displayName = "AppInsightsTracker";
  }
  
  componentWillUnmount() {
    if (!this.componentWillMountTimestamp) {
      throw "ComponentWillMountTimestamp was not initialized. Check if super.componentWillMount() was called";
    }
    let id = this.props.controlNumber;
    if (!id) {
      try {
        id = this.context.store.getState().caseDetails.controlNumber;
      } catch(ex) {
        // console write.
      }
    }
    let username = "not set";
    try {
      username = this.context.store.getState().user.profile.username;
    } catch(ex) {
      username = "not available";
    }
    let measurements = { 
      "Engaged": (Date.now() - this.componentWillMountTimestamp - (this.idleTimeInMs ? this.idleTimeInMs : 0)) / 1000, 
      "Elapsed": (Date.now() - this.componentWillMountTimestamp) / 1000, 
      "Idle": (this.idleTimeInMs ? this.idleTimeInMs : 0) / 1000 
    };
    let properties = { 
      "ComponentName": this.displayName || this.constructor.name, 
      "Username": username,
      "FormId": this.props.formId, 
      "FormStatus": this.props.formStatus,
      "ControlNumber": this.props.controlNumber,
    };
    AppInsights.trackEvent("WebUI Tracker", properties, measurements);
    console.warn(`WebUI Tracker: trackMetric(WebUI engaged, ${JSON.stringify(measurements)}, ${JSON.stringify(properties)}) `); // eslint-disable-line no-console
  }

  UNSAFE_componentWillMount() {
    this.componentWillMountTimestamp = Date.now();
    this.idleTimeInMs = 0;
    let timer = away(30000);
    let self = this;
    timer.on("idle", function () {
      self.startIdleTimer = Date.now();
    });
    timer.on("active", function () {
      self.idleTimeInMs += Date.now() - self.startIdleTimer;
    });
  }

  render() {
    return false;
  }
}

AppInsightsTracker.propTypes = {
  formId: PropTypes.string,
  formStatus: PropTypes.string,
  controlNumber: PropTypes.number,
  location: PropTypes.object
};

AppInsightsTracker.contextTypes = {
  store: PropTypes.object.isRequired
};